export default __webpack_public_path__ + "static/media/dipole.df331fa4.txt";